// BodyPlanet Chat Widget v2 — Clean Rewrite
// initSwipeToClose wird separat definiert (vor IIFE wegen Minifier)
function bpInitSwipe() {
  var handle = document.getElementById('bp-drag-handle');
  if (!handle) return;
  var startY = 0, startTime = 0, dragging = false;
  var win = document.getElementById('bp-chat-window');
  handle.addEventListener('touchstart', function(e) {
    startY = e.touches[0].clientY; startTime = Date.now(); dragging = true;
  }, { passive: true });
  handle.addEventListener('touchmove', function(e) {
    if (!dragging) return;
    var dy = e.touches[0].clientY - startY;
    if (dy > 0 && win) { win.style.transition = 'none'; win.style.transform = 'translateY(' + dy + 'px)'; }
  }, { passive: true });
  handle.addEventListener('touchend', function(e) {
    if (!dragging) return; dragging = false;
    var dy = e.changedTouches[0].clientY - startY;
    var dt = Date.now() - startTime;
    if (win) { win.style.transition = ''; if (dy > 80 || (dy > 40 && dt < 300)) { bpChat.close(); } else { win.style.transform = ''; } }
  }, { passive: true });
}

(function () {
  'use strict';

  var API_BASE = 'https://bodyplanet-chat.beyerdigital.de/api';
  var CONSENT_KEY = 'bp_chat_consent';
  var SESSION_KEY = 'bp_chat_session';
  var MSG_KEY = 'bp_chat_messages';
  var BOOKING_URL = '/pages/termin-buchen?source=chatbot';

  var sessionId = localStorage.getItem(SESSION_KEY);
  var isOpen = false;
  var isLoading = false;

  var $toggle, $win, $messages, $input, $sendBtn, $quickReplies, $recommendation, $bookingCta;

  var QUICK_REPLIES = [
    { label: 'Abnehmen', value: 'Ich möchte abnehmen und Gewicht verlieren.' },
    { label: 'Muskelaufbau', value: 'Ich möchte Muskeln aufbauen.' },
    { label: 'Mehr Energie', value: 'Ich habe wenig Energie und möchte fitter werden.' },
    { label: 'Gelenke & Rücken', value: 'Ich habe Probleme mit meinen Gelenken oder Rücken.' },
    { label: 'Meine Bestellung', value: '', action: 'order_lookup' }
  ];

  // ── INIT ──────────────────────────────────────────────────────────────────
  function init() {
    if (window.__BPv3) return;
    window.__BPv3 = true;
    buildHTML();
    bindEvents();
    setTimeout(function () { if (!isOpen) showBadge(); }, 3000);
  }

  function buildHTML() {
    var html = [
      '<div id="bp-overlay"></div>',
      '<button id="bp-chat-toggle" aria-label="Chat öffnen" aria-expanded="false">',
      '  <span id="bp-chat-badge" class="hidden">1</span>',
      '  <svg viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/></svg>',
      '</button>',
      '<div id="bp-chat-window" role="dialog" aria-modal="true" aria-label="BodyPlanet Chat" aria-hidden="true">',
      '  <div id="bp-drag-handle"></div>',
      '  <div class="bp-chat-header">',
      '    <div class="bp-chat-avatar">BP</div>',
      '    <div class="bp-chat-header-info">',
      '      <div class="bp-chat-header-name">BodyPlanet Assistent</div>',
      '      <div class="bp-chat-header-status"><span class="bp-status-dot"></span> Online</div>',
      '    </div>',
      '    <button id="bp-new-chat" aria-label="Neuer Chat" title="Neuen Chat starten">&#x21BA;</button>',
      '    <button id="bp-close" aria-label="Chat schließen">&#x2715;</button>',
      '  </div>',
      '  <div class="bp-chat-messages" id="bp-messages" role="log" aria-live="polite"></div>',
      '  <div class="bp-quick-replies" id="bp-quick-replies" style="display:none"></div>',
      '  <div id="bp-recommendation" style="padding:0 16px 4px;display:none"></div>',
      '  <div id="bp-booking-cta-wrap" style="padding:0 16px 8px;display:none"></div>',
      '  <div class="bp-chat-input-area">',
      '    <textarea id="bp-input" placeholder="Schreib eine Nachricht..." rows="1" maxlength="1000" aria-label="Nachricht"></textarea>',
      '    <button id="bp-send" aria-label="Senden" disabled>',
      '      <svg viewBox="0 0 24 24"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>',
      '    </button>',
      '  </div>',
      '</div>'
    ].join('\n');

    var root = document.createElement('div');
    root.id = 'bp-chat-root';
    root.innerHTML = html;
    document.body.appendChild(root);

    $toggle       = document.getElementById('bp-chat-toggle');
    $win          = document.getElementById('bp-chat-window');
    $messages     = document.getElementById('bp-messages');
    $input        = document.getElementById('bp-input');
    $sendBtn      = document.getElementById('bp-send');
    $quickReplies = document.getElementById('bp-quick-replies');
    $recommendation = document.getElementById('bp-recommendation');
    $bookingCta   = document.getElementById('bp-booking-cta-wrap');
  }

  function bindEvents() {
    $toggle.addEventListener('click', chatToggle);
    document.getElementById('bp-close').addEventListener('click', chatClose);
    document.getElementById('bp-new-chat').addEventListener('click', function() {
      // Session + Cache löschen
      localStorage.removeItem(SESSION_KEY);
      localStorage.removeItem(MSG_KEY);
      // DOM zurücksetzen
      $messages.innerHTML = '';
      $recommendation.style.display = 'none';
      $recommendation.innerHTML = '';
      $bookingCta.style.display = 'none';
      $bookingCta.innerHTML = '';
      $quickReplies.innerHTML = '';
      $quickReplies.style.display = 'none';
      var pc = document.getElementById('bp-profile-card');
      if (pc) pc.remove();
      // Session-Variable zurücksetzen
      sessionId = null;
      isLoading = false;
      // Neue Session starten
      startSession();
    });
    $input.addEventListener('input', onInput);
    $input.addEventListener('keydown', onKeyDown);
    $sendBtn.addEventListener('click', sendMessage);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) chatClose();
    });
  }

  // ── OPEN / CLOSE ──────────────────────────────────────────────────────────
  function chatToggle() { if (isOpen) chatClose(); else chatOpen(); }

  function chatOpen() {
    isOpen = true;
    $toggle.classList.add('is-open');
    $toggle.setAttribute('aria-expanded', 'true');
    $win.classList.add('is-open');
    $win.setAttribute('aria-hidden', 'false');
    var ov = document.getElementById('bp-overlay');
    if (ov) { ov.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    hideBadge();

    if (!hasConsent()) { showConsent(); return; }

    if ($messages.children.length === 0) loadMsgCache();

    if (!sessionId) {
      if ($messages.children.length === 0) {
        startSession();
      } else {
        // Silent session for returning visitor
        fetch(API_BASE + '/session', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) { sessionId = d.sessionId; localStorage.setItem(SESSION_KEY, sessionId); })
          .catch(function () {});
      }
    }

    setTimeout(function () { $input.focus(); }, 300);
    bpInitSwipe();
  }

  function chatClose() {
    isOpen = false;
    $toggle.classList.remove('is-open');
    $toggle.setAttribute('aria-expanded', 'false');
    $win.classList.remove('is-open');
    $win.setAttribute('aria-hidden', 'true');
    $win.style.transform = '';
    var ov = document.getElementById('bp-overlay');
    if (ov) { ov.classList.remove('is-open'); }
    document.body.style.overflow = '';
  }

  // expose for swipe helper
  window.bpChat = { close: chatClose };

  function showBadge() { var b = document.getElementById('bp-chat-badge'); if (b) b.classList.add('visible'); }
  function hideBadge() { var b = document.getElementById('bp-chat-badge'); if (b) b.classList.remove('visible'); }

  // ── CONSENT ───────────────────────────────────────────────────────────────
  function hasConsent() { return localStorage.getItem(CONSENT_KEY) === '1'; }

  function showConsent() {
    if (document.getElementById('bp-consent-overlay')) return;
    var ov = document.createElement('div');
    ov.id = 'bp-consent-overlay';
    ov.innerHTML = [
      '<div class="bp-consent-card">',
      '  <div class="bp-consent-logo">BP</div>',
      '  <div class="bp-consent-title">BodyPlanet Assistent</div>',
      '  <div class="bp-consent-text">Unser KI-Assistent hilft dir bei der Auswahl passender Produkte und Dienstleistungen. Das Gespräch wird zur Qualitätssicherung gespeichert.</div>',
      '  <button class="bp-consent-btn" id="bp-consent-accept">Chat starten</button>',
      '  <div class="bp-consent-legal">Mit dem Starten des Chats stimmst du unseren <a href="/pages/datenschutz" target="_blank">Datenschutzbestimmungen</a> und <a href="/pages/nutzungsbedingungen" target="_blank">Nutzungsbedingungen</a> zu.</div>',
      '</div>'
    ].join('\n');
    $win.appendChild(ov);
    document.getElementById('bp-consent-accept').addEventListener('click', function () {
      localStorage.setItem(CONSENT_KEY, '1');
      ov.remove();
      if ($messages.children.length === 0) loadMsgCache();
      if (!sessionId) startSession();
      setTimeout(function () { $input.focus(); }, 300);
    });
  }

  // ── SESSION ───────────────────────────────────────────────────────────────
  function startSession() {
    showTyping();
    fetch(API_BASE + '/session', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        sessionId = d.sessionId;
        localStorage.setItem(SESSION_KEY, sessionId);
        removeTyping();
        addMsg('bot', d.greeting || 'Herzlich willkommen! Wie kann ich dir heute helfen?');
        showQuickReplies(QUICK_REPLIES);
      })
      .catch(function () {
        removeTyping();
        addMsg('bot', 'Hallo! Ich bin der BodyPlanet Assistent. Wie kann ich dir helfen?');
        showQuickReplies(QUICK_REPLIES);
      });
  }

  // ── SEND ──────────────────────────────────────────────────────────────────
  function sendMessage() {
    var text = $input.value.trim();
    if (!text || isLoading) return;

    $input.value = '';
    $input.style.height = 'auto';
    $sendBtn.disabled = true;
    $quickReplies.innerHTML = '';
    $quickReplies.style.display = 'none';

    addMsg('user', text);
    lastFailedMsg = text;
    doSend(text);
  }

  function doSend(text) {
    if (!sessionId) {
      // Need session first
      fetch(API_BASE + '/session', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          sessionId = d.sessionId;
          localStorage.setItem(SESSION_KEY, sessionId);
          streamChat(text);
        })
        .catch(function () {
          addErrorMsg('network');
        });
    } else {
      streamChat(text);
    }
  }

  function doSendRequest(text) { streamChat(text); }

  function streamChat(text) {
    showTyping();
    isLoading = true;

    var xhr = new XMLHttpRequest();
    xhr.open('POST', API_BASE + '/chat', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Accept', 'text/event-stream');

    var buffer = '';
    var msgEl = null;
    var lastPos = 0;

    function processSSE(chunk) {
      buffer += chunk;
      var lines = buffer.split('\n');
      buffer = lines.pop() || '';
      lines.forEach(function (line) {
        if (!line.startsWith('data: ')) return;
        var parsed;
        try { parsed = JSON.parse(line.slice(6)); } catch (e) { return; }
        switch (parsed.type) {
          case 'session':
            sessionId = parsed.sessionId;
            localStorage.setItem(SESSION_KEY, sessionId);
            break;
          case 'delta':
            if (!msgEl) { removeTyping(); msgEl = addMsg('bot', '', true); }
            appendDelta(msgEl, parsed.content);
            break;
          case 'recommendation':
            showRecommendation(parsed.data);
            if (parsed.data && parsed.data.bookingUrl) showBookingBtn(parsed.data.bookingUrl, parsed.data.supplementNames);
            break;
          case 'profile_card':
            showProfileCard(parsed.data);
            break;
          case 'booking_cta':
            showBookingBtn(parsed.bookingUrl, null);
            break;
          case 'error':
            removeTyping();
            addErrorMsg(parsed.message || null);
            break;
          case 'done':
            scrollBottom();
            break;
        }
      });
    }

    xhr.onprogress = function () {
      var newData = xhr.responseText.slice(lastPos);
      lastPos = xhr.responseText.length;
      if (newData) processSSE(newData);
    };

    xhr.onload = function () {
      if (xhr.status === 429) {
        removeTyping();
        addErrorMsg('rate_limit');
        isLoading = false;
        return;
      }
      if (xhr.status >= 500) {
        removeTyping();
        addErrorMsg(null);
        isLoading = false;
        return;
      }
      var newData = xhr.responseText.slice(lastPos);
      if (newData) processSSE(newData);
      removeTyping();
      isLoading = false;
      lastFailedMsg = null; // Erfolg — kein Retry nötig
    };

    xhr.onerror = function () {
      removeTyping();
      addErrorMsg('network');
      isLoading = false;
    };

    xhr.ontimeout = function () {
      removeTyping();
      addErrorMsg('timeout');
      isLoading = false;
    };

    xhr.timeout = 30000;

    xhr.send(JSON.stringify({ sessionId: sessionId, message: text }));
  }

  // ── INPUT HANDLERS ────────────────────────────────────────────────────────
  function onInput() {
    $sendBtn.disabled = !$input.value.trim();
    $input.style.height = 'auto';
    $input.style.height = Math.min($input.scrollHeight, 100) + 'px';
  }

  function onKeyDown(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (!$sendBtn.disabled) sendMessage();
    }
  }

  // ── DOM HELPERS ───────────────────────────────────────────────────────────
  function addMsg(sender, text, streaming) {
    if (!streaming && text) saveMsgCache(sender, text);
    var isUser = sender === 'user';
    var row = document.createElement('div');
    row.className = isUser ? 'bp-msg-row bp-msg-user' : 'bp-msg-row bp-msg-bot';
    if (!isUser) {
      var av = document.createElement('div');
      av.className = 'bp-msg-avatar-mini';
      av.textContent = 'BP';
      row.appendChild(av);
    }
    var bubble = document.createElement('div');
    bubble.className = 'bp-bubble';
    if (streaming) {
      bubble.innerHTML = '<span class="bp-cursor">&#x258C;</span>';
    } else {
      bubble.innerHTML = fmtMsg(text);
    }
    row.appendChild(bubble);
    $messages.appendChild(row);
    scrollBottom();
    return bubble;
  }

  function appendDelta(bubble, delta) {
    var raw = (bubble.dataset.raw || '') + delta;
    bubble.dataset.raw = raw;
    bubble.innerHTML = fmtMsg(raw) + '<span class="bp-cursor">&#x258C;</span>';
    scrollBottom();
  }

  function fmtMsg(text) {
    if (!text) return '';
    return text
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>')
      .replace(/(https?:\/\/[^\s<>*]+)/g, '<a href="$1" target="_blank" rel="noopener">$1</a>')
      .replace(/\n/g, '<br>');
  }

  var lastFailedMsg = null;

  function addErrorMsg(type) {
    // Alten Error entfernen
    var old = document.getElementById('bp-error-msg');
    if (old) old.remove();

    var msgs = {
      'rate_limit': '⏱️ Du schreibst ganz schön schnell! Bitte kurz warten und dann nochmal versuchen.',
      'too_long': '✏️ Deine Nachricht ist etwas lang — bitte kürzer fassen (max. 1000 Zeichen).',
      'network': '📶 Keine Verbindung zum Server. Bitte überprüfe deine Internetverbindung.',
      'timeout': '⏳ Die Antwort dauert zu lange. Bitte versuche es nochmal.',
    };
    var text = msgs[type] || '😅 Da ist leider etwas schiefgelaufen. Kurz warten und nochmal probieren?';

    var row = document.createElement('div');
    row.id = 'bp-error-msg';
    row.className = 'bp-error-row';
    row.innerHTML = [
      '<div class="bp-error-bubble">',
      '  <span>' + escHtml(text) + '</span>',
      lastFailedMsg ? '  <button class="bp-retry-btn" onclick="(function(){document.getElementById(\'bp-error-msg\').remove();bpRetry();})()">' + '↩ Nochmal senden</button>' : '',
      '</div>',
    ].join('');
    $messages.appendChild(row);
    scrollBottom();
  }

  function bpRetry() {
    if (lastFailedMsg) {
      var text = lastFailedMsg;
      lastFailedMsg = null;
      // Direkt senden ohne nochmal in messages zu addieren
      isLoading = true;
      showTyping();
      doSendRequest(text);
    }
  }

  function showTyping() {
    removeTyping();
    var el = document.createElement('div');
    el.id = 'bp-typing';
    el.className = 'bp-msg-row bp-msg-bot';
    var av = document.createElement('div');
    av.className = 'bp-msg-avatar-mini';
    av.textContent = 'BP';
    var bubble = document.createElement('div');
    bubble.className = 'bp-bubble';
    bubble.innerHTML = '<div class="bp-typing-indicator"><span></span><span></span><span></span></div>';
    el.appendChild(av);
    el.appendChild(bubble);
    $messages.appendChild(el);
    scrollBottom();
  }

  function removeTyping() {
    var el = document.getElementById('bp-typing');
    if (el) el.remove();
  }

  function scrollBottom() {
    if ($messages) $messages.scrollTop = $messages.scrollHeight;
  }

  function showQuickReplies(replies) {
    $quickReplies.innerHTML = '';
    $quickReplies.style.display = 'flex';
    replies.forEach(function (r) {
      var btn = document.createElement('button');
      btn.className = 'bp-quick-reply';
      btn.textContent = r.label;
      btn.addEventListener('click', function () {
        if (r.action === 'order_lookup') { showOrderLookup(); return; }
        $quickReplies.innerHTML = '';
        $quickReplies.style.display = 'none';
        addMsg('user', r.value);
        doSend(r.value);
      });
      $quickReplies.appendChild(btn);
    });
  }

  function showRecommendation(data) {
    if (!data || !data.supplements || !data.supplements.length) return;
    $recommendation.style.display = 'flex';
    $recommendation.innerHTML = '';
    var title = document.createElement('div');
    title.className = 'bp-recommendation-title';
    title.textContent = 'Meine Empfehlung für dich';
    $recommendation.appendChild(title);
    data.supplements.forEach(function (s) {
      var a = document.createElement('a');
      a.className = 'bp-supplement-item';
      a.href = s.url;
      a.target = '_blank';
      a.rel = 'noopener';
      a.innerHTML = '<span class="bp-supplement-name">' + escHtml(s.label) + '</span>';
      if (s.price) {
        var price = document.createElement('span');
        price.className = 'bp-supplement-price';
        price.textContent = s.price;
        a.appendChild(price);
      }
      $recommendation.appendChild(a);
    });
  }

  function showBookingBtn(url, names) {
    $bookingCta.style.display = 'block';
    var label = names && names.length
      ? 'Erstgespräch zu ' + names.slice(0, 2).join(' & ') + ' buchen'
      : 'Kostenloses Erstgespräch buchen';
    $bookingCta.innerHTML = '<a class="bp-booking-btn" href="' + escHtml(url) + '" target="_blank" rel="noopener">' + label + '</a>';
  }

  function showProfileCard(data) {
    if (!data || !data.image) return;
    // Nur einmal anzeigen
    if (document.getElementById('bp-profile-card')) return;
    var card = document.createElement('div');
    card.id = 'bp-profile-card';
    card.className = 'bp-profile-card';
    card.innerHTML = [
      '<div class="bp-profile-card-inner">',
      '  <img class="bp-profile-img" src="' + escHtml(data.image) + '" alt="' + escHtml(data.name) + '">',
      '  <div class="bp-profile-info">',
      '    <div class="bp-profile-name">' + escHtml(data.name) + '</div>',
      '    <div class="bp-profile-title">' + escHtml(data.title) + '</div>',
      '    <div class="bp-profile-sub">' + escHtml(data.subtitle) + '</div>',
      '    <a class="bp-profile-cta" href="' + escHtml(data.ctaUrl) + '" target="_blank" rel="noopener">' + escHtml(data.cta) + '</a>',
      '  </div>',
      '</div>',
    ].join('');
    $messages.appendChild(card);
    scrollBottom();
  }

  function showOrderLookup() {
    $quickReplies.innerHTML = '';
    $quickReplies.style.display = 'none';
    var ov = document.createElement('div');
    ov.id = 'bp-order-overlay';
    ov.innerHTML = [
      '<div class="bp-order-card">',
      '  <div class="bp-order-title">Bestellstatus prüfen</div>',
      '  <input id="bp-order-num" type="text" placeholder="Bestellnummer (z.B. #1234)" class="bp-order-input" />',
      '  <input id="bp-order-email" type="email" placeholder="E-Mail-Adresse" class="bp-order-input" />',
      '  <button id="bp-order-submit" class="bp-order-submit-btn">Status abrufen</button>',
      '  <button id="bp-order-cancel" class="bp-order-cancel-btn">Abbrechen</button>',
      '</div>'
    ].join('\n');
    $win.appendChild(ov);
    document.getElementById('bp-order-cancel').addEventListener('click', function () { ov.remove(); });
    document.getElementById('bp-order-submit').addEventListener('click', function () {
      var num = document.getElementById('bp-order-num').value.trim();
      var email = document.getElementById('bp-order-email').value.trim();
      if (!num || !email) { alert('Bitte Bestellnummer und E-Mail eingeben.'); return; }
      ov.remove();
      addMsg('user', 'Bestellstatus für ' + num);
      fetch(API_BASE + '/order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ orderNumber: num, email: email })
      })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.error) { addMsg('bot', d.error); return; }
        var msg = 'Bestellung ' + d.name + ' — Status: ' + d.fulfillmentStatus + '\nBestellt am: ' + new Date(d.createdAt).toLocaleDateString('de-DE') + '\nSumme: ' + d.totalPrice;
        if (d.trackingUrl) msg += '\nTracking: ' + d.trackingUrl;
        addMsg('bot', msg);
      })
      .catch(function () { addMsg('bot', 'Bestellung konnte nicht geladen werden. Bitte erneut versuchen.'); });
    });
  }

  // ── CACHE ─────────────────────────────────────────────────────────────────
  function saveMsgCache(sender, text) {
    try {
      var cache = JSON.parse(localStorage.getItem(MSG_KEY) || '[]');
      cache.push({ sender: sender, text: text, ts: Date.now() });
      if (cache.length > 50) cache.splice(0, cache.length - 50);
      localStorage.setItem(MSG_KEY, JSON.stringify(cache));
    } catch (e) {}
  }

  function loadMsgCache() {
    try {
      var cache = JSON.parse(localStorage.getItem(MSG_KEY) || '[]');
      cache.forEach(function (m) { addMsg(m.sender, m.text); });
    } catch (e) {}
  }

  function escHtml(s) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(s || ''));
    return d.innerHTML;
  }

  // ── BOOT ──────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
